export default __webpack_public_path__ + "static/media/wifi.16b30bfa.svg";